import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes';
import VueJWT from 'vuejs-jwt'


const router = new VueRouter({
    mode: "history",
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});
// 라우터 정의
Vue.use(VueRouter);

let JwtOption = {
    signKey: 'XkgXys83uA-3nwt9r3QPoalndVLWf_np_3H37Y6oKeY',
    storage: 'localStorage',
    keyName: 'com.dgmonglab.eotapptoken',
    ignoreExpiration: false,       // set true to ignore expiration date
    ignoreNotBefore: false,       // set true to ignore 'not before' date
}


Vue.use(VueJWT, JwtOption)
router.beforeEach(function (to, from, next) { // 토큰이 로컬스토리지에 담겼을 시 사용
    // to: 이동할 url에 해당하는 라우팅 객체
    if (to.matched.some(function (routeInfo) {
        return routeInfo.meta.authRequired;
    })) {
        if (Vue.$jwt.hasToken()) {
            let token = Vue.$jwt.getToken();
            var regex = /"/gi;
            let jwtToken = token.replace(regex, '');
            let secret = 'XkgXys83uA-3nwt9r3QPoalndVLWf_np_3H37Y6oKeY'
            let tokenObject = Vue.$jwt.decode(jwtToken, secret);
            if (!tokenObject || !tokenObject.hasOwnProperty('mb_no')) {
                // next({
                //     path: '/auth',
                //     query: { redirect: to.fullPath }
                // })
                next({
                    path: '/onboarding',
                    query: {redirect: to.fullPath}
                })
            } else {
                next(); // 페이지 전환
            }

        } else {
            // next({
            //     path: '/auth',
            //     query: { redirect: to.fullPath }
            // })
            next({
                path: '/onboarding',
                query: {redirect: to.fullPath}
            })
        }

    } else {
        next(); // 페이지 전환
    }
    ;
});


export default router;
